import React from 'react';
import Button from './Button';

const EmptyState = ({
  icon: Icon,
  title = 'Nothing here yet',
  description,
  actionLabel,
  onAction,
  className = '',
}) => (
  <div
    className={`flex flex-col items-center justify-center text-center py-12 px-4 ${className}`}
    data-testid="empty-state"
  >
    {Icon && (
      <div className="mb-3 p-3 rounded-full bg-secondary-100 dark:bg-secondary-700 text-secondary-500">
        <Icon className="h-6 w-6" aria-hidden="true" />
      </div>
    )}
    <h3 className="text-sm font-semibold text-secondary-900 dark:text-white">{title}</h3>
    {description && (
      <p className="mt-1 text-sm text-secondary-500 dark:text-secondary-400 max-w-sm">
        {description}
      </p>
    )}
    {actionLabel && onAction && (
      <Button variant="primary" className="mt-4" onClick={onAction}>
        {actionLabel}
      </Button>
    )}
  </div>
);

export default EmptyState;
